import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, ResolveFn} from '@angular/router';
import {Observable, of} from 'rxjs';
import {MyTraceyDataStore} from '@store';
import {UserEventsService, UserEventType} from "@services";
import {MyTraceyTabs} from "@pages";

export const UserUpcomingResolver = MyTraceyDataStore.on(s => s.upcoming$);
export const UserResultsResolver = MyTraceyDataStore.on(s => s.results$);
export const UserFavoritesResolver = MyTraceyDataStore.on(s => s.favorites$);
export const UserRecommendedResolver = MyTraceyDataStore.on(s => s.recommended$);
export const UserStatisticResolver = MyTraceyDataStore.on(s => s.userStatistics$);
export const UserRegistrationsResolver = MyTraceyDataStore.on(s => s.registrations$);


const tabToEventType: Partial<Record<MyTraceyTabs, UserEventType>> = {
    [MyTraceyTabs.UPCOMING]: UserEventType.UPCOMING,
    [MyTraceyTabs.FAVORITES]: UserEventType.FAVORITE,
    [MyTraceyTabs.RESULTS]: UserEventType.RESULTS
};

const resolveByTab = <T>(fetchFn: (service: UserEventsService, type: UserEventType) => Observable<T>): ResolveFn<Observable<T | []>> =>
    (route: ActivatedRouteSnapshot) => {
        const eventType = tabToEventType[route.data['activeTab'] as MyTraceyTabs];
        if (!eventType) return of([]);
        return fetchFn(inject(UserEventsService), eventType);
    };

export const UserEventsSportsResolver = resolveByTab((s, type) => s.getUserEventsSports(type));
export const UserEventsCountriesResolver = resolveByTab((s, type) => s.getUserEventsCountries(type));